import { render, staticRenderFns } from "./ConfirmPopup.vue?vue&type=template&id=b2536f6c&scoped=true"
import script from "./ConfirmPopup.vue?vue&type=script&lang=js"
export * from "./ConfirmPopup.vue?vue&type=script&lang=js"
import style0 from "./ConfirmPopup.vue?vue&type=style&index=0&id=b2536f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2536f6c",
  null
  
)

export default component.exports